<div class="mb-3">
  @if (mayView) {
    <div>
      <div>
        @if (mode === 'registrations') {
          <h1 class="pb-2 border-bottom fw-light" i18n>Registrierungen</h1>
        } @else {
          <h1 class="pb-2 border-bottom fw-light" i18n>Benutzer</h1>
        }
      </div>
      <kendo-grid
        [data]="list.gridData"
        [pageable]="true"
        [skip]="list.state.skip"
        [pageSize]="list.state.pageSize"
        [sortable]="true"
        [sort]="list.state.sort"
        (pageChange)="list.onPageChange($event)"
        (sortChange)="list.onSortChange($event)"
        [reorderable]="true"
        [resizable]="true"
        >
        <ng-template kendoGridNoRecordsTemplate>
          @if (mode === 'registrations') {
            <app-grid-no-records [loading]="list.loading" loadingText="Registrierungen werden geladen…" i18n-loadingText></app-grid-no-records>
          } @else {
            <app-grid-no-records [loading]="list.loading" loadingText="Benutzer werden geladen…" i18n-loadingText></app-grid-no-records>
          }
        </ng-template>
        <ng-template kendoGridToolbarTemplate>
          <button kendoGridPDFCommand icon="file-pdf" i18n>PDF-Export</button>
          @if (mode === 'users') {
            <button
              [disabled]="!createAllowed"
              class="btn btn-primary ms-auto"
              type="button"
              [routerLink]="['/authentication/registerchilduser']"
              [queryParams]="{ returnUrl: ApplicationPaths.Users }"
              i18n
              >
              Neuen Benutzer erstellen
            </button>
          }
        </ng-template>
        @if (mode === 'registrations') {
          <kendo-grid-column field="customer.fullName" [sortable]="false" i18n-title title="Kunde" [width]="150">
          </kendo-grid-column>
        }
        <kendo-grid-column field="user.fullName" [sortable]="false" i18n-title title="Name" [width]="150">
        </kendo-grid-column>
        <kendo-grid-column field="user.email" [sortable]="false" i18n-title title="E-Mail" [width]="150">
        </kendo-grid-column>
        <kendo-grid-column field="role" i18n-title title="Benutzergruppe" [width]="150">
        </kendo-grid-column>
        <kendo-grid-column field="status" i18n-title title="Status" [width]="120">
        </kendo-grid-column>
        @if (mode === 'registrations' || profile?.isActive) {
          <kendo-grid-command-column
            i18n-title
            title="Bearbeiten"
            [width]="70"
            >
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="d-flex justify-content-center gap-2">
                <button type="button" class="btn btn-sm btn-outline-secondary" title="Bearbeiten" aria-label="Bearbeiten" i18n-title i18n-aria-label (click)="onEdit(dataItem.id)">
                  <i>
                    <fa-icon [icon]="faEdit"></fa-icon>
                  </i>
                </button>
              </div>
            </ng-template>
          </kendo-grid-command-column>
        }
        <kendo-grid-pdf appGridPdf [fileName]="mode === 'registrations' ? 'Registrierungen.pdf' : 'Benutzer.pdf'" [allPages]="true" paperSize="A4" [repeatHeaders]="true" [scale]="0.75">
          <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm" ></kendo-grid-pdf-margin>
          <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
            @if (mode === 'registrations') {
              <app-pdf-page title="Registrierungen" i18n-title [pageNum]="pageNum" [totalPages]="totalPages"></app-pdf-page>
            } @else {
              <app-pdf-page title="Benutzerliste" i18n-title [pageNum]="pageNum" [totalPages]="totalPages"></app-pdf-page>
            }
          </ng-template>
        </kendo-grid-pdf>
      </kendo-grid>
    </div>
  }
</div>

@if (mayView) {
  <div class="mb-3">
    <div>
      <app-non-confirmed-users [mode]="mode === 'registrations' ? 'primary' : 'secondary'"></app-non-confirmed-users>
    </div>
  </div>
}
